import React from 'react';

export const CallLogsDrawerIncomingCall = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16699 4.17253C3.94598 4.17253 3.73402 4.26032 3.57774 4.4166C3.4265 4.56784 3.33939 4.77123 3.33393 4.9845C3.52559 8.02111 4.81832 10.884 6.97027 13.0359C9.12223 15.1879 11.9851 16.4806 15.0217 16.6723C15.235 16.6668 15.4383 16.5797 15.5896 16.4284C15.7459 16.2722 15.8337 16.0602 15.8337 15.8392V13.0701L12.8498 11.8765L11.9649 13.3513C11.7418 13.7232 11.2707 13.8617 10.8817 13.6699C8.90761 12.6963 7.30987 11.0986 6.33628 9.12445C6.14445 8.73549 6.28302 8.26442 6.65491 8.04128L8.12969 7.15642L6.93613 4.17253H4.16699ZM2.39923 3.23809C2.86807 2.76925 3.50395 2.50586 4.16699 2.50586H7.50033C7.84108 2.50586 8.1475 2.71332 8.27406 3.0297L9.94072 7.19637C10.0926 7.57613 9.94647 8.01 9.59574 8.22044L8.20074 9.05744C8.88729 10.1771 9.82906 11.1189 10.9487 11.8054L11.7857 10.4104C11.9962 10.0597 12.4301 9.91356 12.8098 10.0655L16.9765 11.7321C17.2929 11.8587 17.5003 12.1651 17.5003 12.5059V15.8392C17.5003 16.5022 17.2369 17.1381 16.7681 17.607C16.2993 18.0758 15.6634 18.3392 15.0003 18.3392C14.9835 18.3392 14.9666 18.3387 14.9498 18.3377C11.496 18.1278 8.23845 16.6611 5.79176 14.2144C3.34507 11.7677 1.87841 8.51018 1.66853 5.05641C1.6675 5.03958 1.66699 5.02272 1.66699 5.00586C1.66699 4.34282 1.93038 3.70693 2.39923 3.23809Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9117 8.09577C11.5863 7.77033 11.5863 7.24269 11.9117 6.91725L16.0784 2.75059C16.4038 2.42515 16.9315 2.42515 17.2569 2.75059C17.5823 3.07602 17.5823 3.60366 17.2569 3.9291L13.0902 8.09577C12.7648 8.4212 12.2372 8.4212 11.9117 8.09577Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6676 7.50651C16.6676 7.96675 16.2945 8.33984 15.8343 8.33984L12.501 8.33984C12.0407 8.33984 11.6676 7.96675 11.6676 7.50651L11.6676 4.17318C11.6676 3.71294 12.0407 3.33984 12.501 3.33984C12.9612 3.33984 13.3343 3.71294 13.3343 4.17318L13.3343 6.67318L15.8343 6.67318C16.2945 6.67318 16.6676 7.04627 16.6676 7.50651Z"
      fill="white"
    />
  </svg>
);
